import { AnyAction } from '@reduxjs/toolkit';
import { GetCustomerUsersWithRoleRoutine } from '../redux-routines';
import type { ICustomerUsersWithRolesState } from '../interfaces';

export const initialState: ICustomerUsersWithRolesState = {
  data: [],
  apiKeys: [],
  error: null,
  isFetching: false,
};

export const customerUsersWithRolesReducer = (
  state: ICustomerUsersWithRolesState = initialState,
  action: AnyAction,
): ICustomerUsersWithRolesState => {
  switch (action.type) {
    case GetCustomerUsersWithRoleRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case GetCustomerUsersWithRoleRoutine.SUCCESS: {
      const payload = GetCustomerUsersWithRoleRoutine.getSuccessPayload(action);
      return {
        ...state,
        data: payload.users,
        apiKeys: payload.apiKeys,
        isFetching: false,
      };
    }
    case GetCustomerUsersWithRoleRoutine.FAILURE: {
      return {
        ...state,
        error: GetCustomerUsersWithRoleRoutine.getFailurePayload(action),
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
